import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import TaskResponsesList from './TaskResponsesList'

export default function TaskResponses() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/task_responses" component={TaskResponsesList} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}